import RepLegacyController from './rep-legacy.controller';
import Template from './rep-legacy.html';

export default {
	controller: RepLegacyController,
	template: Template
};
